export default __webpack_public_path__ + "static/4i-89f5ae13073b5adc8780c46f696dad9d.woff2";